module.exports = __webpack_public_path__ + "img/btn_bnr_arr_pause.5a602972.svg";